// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "checkmark-opUF";
var _3 = "container-pd23";
var _4 = "#575757";
var _5 = "1.5rem";
var _6 = "#dedede";
var _7 = "#adf";
var _8 = "1rem";
var _9 = "#bebebe";
var _a = ".8rem";
var _b = "#000";
export { _1 as "busBlue", _2 as "checkmark", _3 as "container", _4 as "darkGrey", _5 as "extraLargeFontSize", _6 as "lightGrey", _7 as "lightblue", _8 as "mediumFontSize", _9 as "mediumLightGrey", _a as "smallFontSize", _b as "unusedNodeColor" }
